export const ru = {
    'to-main-page': 'На главную',
    'edit-field-placeholder': 'Укажите или будет сгенерировано',
    'edit-field-save': 'Сохранить',
    'edit-field-cancel': 'Отменить',
    'edit-button-title': 'Изменить название звонка',
}
